import ".././styles/CTA.css";
import ctaimage from ".././assets/ctaimage.png";
import { NavLink } from 'react-router-dom'; 
import React, { useState } from "react";

function CTA() {
    return (
            <div className="call-to-action">
                <div className="cta-img-container">
                    <img className="cta-image" src={ctaimage}></img>
                </div>
                <div className="cta-description">
                    <h2 className="cta-title">Feel Free to Contact Us!</h2>
                    <p className="cta-description-contents"></p> {/* <-- Description */}
                    <div className="cta-buttons">
                        <NavLink to="/donate#" className="button-1"><h4>Donate</h4></NavLink>
                        <NavLink to="/memberships" className="button-2"><h4>Join Today</h4></NavLink>
                    </div>
                </div>
            </div>
    );
}

export default CTA;